import axios from "axios";
import api from "../api";
import store from "@/store";
import filter_service from "./filter-service";

function create(params, address) {
  return new Promise((resolve, reject) => {
    // if (!address) {
    axios
      .post(api.address, params)
      .then(async (response) => {
        store.dispatch("address/setAddress", response.data);
        resolve({
          address: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
    // } else {
    // resolve({
    // address: address,
    // })
    // }
  });
}

async function read(params = {}) {
  let pagination = params.with_pagination
    ? params.pagination
      ? `?isPaginated=1&page=${params.pagination.currentPage}&perPage=${params.pagination.perPage}`
      : "?isPaginated=1"
    : "";
  let paginate = params.with_pagination ? { paginate: true } : {};
  return new Promise((resolve, reject) => {
    axios
      .get(`${api.address}${pagination}`, params)
      .then((response) => {
        if (params.with_pagination) {
          resolve({
            addresses: { ...paginate, ...response.data },
          });
        } else {
          resolve({
            addresses: response.data,
          });
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function update(body = {}) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${api.address}/${body.id}`, body.params)
      .then(async (response) => {
        store.dispatch("alerts/success", "Endereço salvo com sucesso");
        resolve({
          address: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function orderUpdate(body = {}) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${api.orders}/${body.id}/address`, body.params)
      .then(async (response) => {
        store.dispatch("alerts/success", "Endereço salvo com sucesso");
        resolve({
          address: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}


async function destroy(id) {
  return new Promise(async (resolve, reject) => {
    axios
      .delete(`${api.url}/${id}`)
      .then((response) => {
        resolve({
          data_name: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getCities(params) {
  return new Promise(async (resolve, reject) => {
    let filter_params = "";
    if (params?.url_filter) {
      let states = await getStates();
      let state = states.states.find(
        (state) => state.id == params.url_params.state
      );
      filter_params = filter_service.filter_params({
        url_filter: params.url_filter,
        url_params: { uf: state.uf },
      });
    }
    axios
      .get(`${api.cities}${filter_params}`)
      .then((response) => {
        resolve({
          cities: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getStates() {
  return new Promise((resolve, reject) => {
    axios
      .get(api.states)
      .then((response) => {
        resolve({
          states: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  read,
  create,
  update,
  orderUpdate,
  destroy,
  getCities,
  getStates,
};
